<template>
  <wv-steak-house-default-section :section="section" :menu="menu" menu-item-component="wv-steak-house-wine-list-item"
                                  class="menu--section-wine_list"></wv-steak-house-default-section>
</template>

<script lang="ts">
/**
 * Special component for WV Steak House wine list section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - Copy <WvSteakHouseWineListSection> component from <WvSteakHouseCocktailSection>.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <WvSteakHouseWineListSection>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <WvSteakHouseWineListSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  components: {
    WvSteakHouseDefaultSection,
  },
  name: "WvSteakHouseWineListSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-wine_list:deep(.menu--section_subgroup_title) {
  font-weight: 400;
  text-align: left;
  margin-bottom: 0.3em;
  font-size: 1.3em;
}

.menu--section-wine_list.menu--section-show_pricing_header:deep(.menu--section_subgroup_title) span {
  font-weight: 400;
}

.menu--section-wine_list:deep(.menu--item_subgroup) {
  grid-gap: 0.25em;
}

.menu--section-wine_list.menu--section-show_bin:not(.menu--section-show_pricing_header):deep(.menu--item_subgroup-show_BIN .menu--section_subgroup_title span:first-child) {
  grid-column: 2 / -1;
}

.menu--section-wine_list:deep(.menu--section_title) {
  padding-bottom: 1em;
}

.visual_menu--section:deep(.menu--item_subgroup) {
  margin-top: 1.5em;
}
</style>